import { appRoutes } from "../../../constants/appRoutes";

export const membersRoute = {
    path: appRoutes.members.path,
    lazy: () => import("../../../pages/Members"),
}